<template>
  <div>
    <div class="mb5"></div>
    <form @onsubmit.prevent action>
      <div class="row mb5">
        <div class="col-md-4"></div>
        <div class="col-md-2 text-center">
          <label class="form-control-label text-bold"></label>
        </div>
      </div>
      <div
        v-for="(field, index) in fields"
        v-bind:key="index"
        class="row"
        style="margin-bottom: 10px;"
      >
        <div class="col-md-4">
          <label
            :for="field.name"
            class="form-control-label"
          >{{(index+1)}}. {{getLabel(field.label)}}</label>
        </div>
        <div class="col col-md-2">
          <input
            :type="field.type"
            v-model.number="formData[field.name]"
            :id="field.name"
            placeholder="Enter"
            class="form-control"
          >
          <!-- <small v-if="errors[field.name].source" class="form-text text-danger">{{errors[field.name].source}}</small> -->
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group pull-right">
            <!-- <submitButton @click.prevent="submit" type="submit" class="btn btn-info">Submit</submitButton> -->
            <button type="button" class="btn btn-primary" @click="showSmallModal">Submit</button>
          </div>
        </div>
      </div>
      <PinCheck
        :show.sync="show"
        ref="smallModal"
        v-bind:small="true"
        @submitForm="submitForm"
        :cancelClass="'btn btn-secondary'"
      ></PinCheck>
    </form>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import PinCheck from "@/components/PinCheck.vue";
export default {
  components: { PinCheck },
  mixins: [commonMixins],
  props: ["companyData", "isFromComp", "selCompany"],
  created() {
    // this.getProjectedFormData();
    console.log(this.pType, "=> ", this.globalData);
    // if (localStorage.getItem("selcomp")) {
    //   var selComp = JSON.parse(localStorage.getItem("selcomp"));
    //   this.company.co_code = selComp.co_code;
    //   this.company.companyname = selComp.companyname;
    //   // this.getProjectedFormData();
    // }
  },
  data() {
    return {
      show: false,
      curDate: new Date(),
      company: {},
      globalData: {
        sum_of_negative_sales_growth_per_total_no_of_value_for_sales_growth_benchmark:
          "",
        number_of_time_sign_change_sales_growth_gt_benchmark: "",
        last_year_sales_growth_gt_benchmark: "",
        sum_of_negative_profit_growth_per_total_no_of_value_for_profit_growth_benchmark:
          "",
        number_of_time_sign_change_profit_growth_gt_benchmark: "",
        last_year_profit_growth_gt_benchmark: "",
        avg_gross_margin_gt_benchmark: "",
        sum_of_all_positive_for_change_in_gross_margin_per_total_no_of_value_for_change_in_gross_margin_gt_benchmark:
          "",
        avg_roe_gt_benchmark: "",
        latest_roe_gt_benchmark: "",
        count_of_negative_for_change_in_cfo_per_ebitda_per_total_no_of_values_change_in_cfo_per_ebitda_gt_benchmark:
          "",
        count_of_negative_for_change_in_lna_per_net_worth_per_total_no_of_values_change_in_lna_per_net_worth_gt_benchmark:
          "",
        change_in_cfo_per_ebitda_gt_benchmark: "",
        change_in_cfo_per_ebitda_lt_benchmark: "",
        avg_change_in_cfo_per_ebitda_last_three_year_gt_benchmark: "",
        change_in_lna_per_net_worth_gt_benchmark: "",
        change_in_lna_per_net_worth_lt_benchmark: "",
        avg_change_in_lna_per_net_worth_last_three_year_gt_benchmark: ""
      },
      fields: [
        {
          label:
            "sum_of_negative_sales_growth_per_total_no_of_value_for_sales_growth_benchmark",
          name:
            "sum_of_negative_sales_growth_per_total_no_of_value_for_sales_growth_benchmark",
          type: "text",
          value: ""
        },
        {
          label: "number_of_time_sign_change_sales_growth_gt_benchmark",
          name: "number_of_time_sign_change_sales_growth_gt_benchmark",
          type: "text",
          value: ""
        },
        {
          label: "last_year_sales_growth_gt_benchmark",
          name: "last_year_sales_growth_gt_benchmark",
          type: "text",
          value: ""
        },
        {
          label:
            "sum_of_negative_profit_growth_per_total_no_of_value_for_profit_growth_benchmark",
          name:
            "sum_of_negative_profit_growth_per_total_no_of_value_for_profit_growth_benchmark",
          type: "text",
          value: ""
        },
        {
          label: "number_of_time_sign_change_profit_growth_gt_benchmark",
          name: "number_of_time_sign_change_profit_growth_gt_benchmark",
          type: "text",
          value: ""
        },
        {
          label: "last_year_profit_growth_gt_benchmark",
          name: "last_year_profit_growth_gt_benchmark",
          type: "text",
          value: ""
        },
        {
          label: "avg_gross_margin_gt_benchmark",
          name: "avg_gross_margin_gt_benchmark",
          type: "text",
          value: ""
        },
        {
          label:
            "sum_of_all_positive_for_change_in_gross_margin_per_total_no_of_value_for_change_in_gross_margin_gt_benchmark",
          name:
            "sum_of_all_positive_for_change_in_gross_margin_per_total_no_of_value_for_change_in_gross_margin_gt_benchmark",
          type: "text",
          value: ""
        },
        {
          label: "avg_roe_gt_benchmark",
          name: "avg_roe_gt_benchmark",
          type: "text",
          value: ""
        },
        {
          label: "latest_roe_gt_benchmark",
          name: "latest_roe_gt_benchmark",
          type: "text",
          value: ""
        },
        {
          label:
            "count_of_negative_for_change_in_cfo_per_ebitda_per_total_no_of_values_change_in_cfo_per_ebitda_gt_benchmark",
          name:
            "count_of_negative_for_change_in_cfo_per_ebitda_per_total_no_of_values_change_in_cfo_per_ebitda_gt_benchmark",
          type: "text",
          value: ""
        },
        {
          label:
            "count_of_negative_for_change_in_lna_per_net_worth_per_total_no_of_values_change_in_lna_per_net_worth_gt_benchmark",
          name:
            "count_of_negative_for_change_in_lna_per_net_worth_per_total_no_of_values_change_in_lna_per_net_worth_gt_benchmark",
          type: "text",
          value: ""
        },
        {
          label: "change_in_cfo_per_ebitda_gt_benchmark",
          name: "change_in_cfo_per_ebitda_gt_benchmark",
          type: "text",
          value: ""
        },
        {
          label: "change_in_cfo_per_ebitda_lt_benchmark",
          name: "change_in_cfo_per_ebitda_lt_benchmark",
          type: "text",
          value: ""
        },
        {
          label: "avg_change_in_cfo_per_ebitda_last_three_year_gt_benchmark",
          name: "avg_change_in_cfo_per_ebitda_last_three_year_gt_benchmark",
          type: "text",
          value: ""
        },
        {
          label: "change_in_lna_per_net_worth_gt_benchmark",
          name: "change_in_lna_per_net_worth_gt_benchmark",
          type: "text",
          value: ""
        },
        {
          label: "change_in_lna_per_net_worth_lt_benchmark",
          name: "change_in_lna_per_net_worth_lt_benchmark",
          type: "text",
          value: ""
        },
        {
          label: "avg_change_in_lna_per_net_worth_last_three_year_gt_benchmark",
          name: "avg_change_in_lna_per_net_worth_last_three_year_gt_benchmark",
          type: "text",
          value: ""
        }
      ],
      formData: {},
      errors: [],
      defaultSrc: "",
      pType: "projected"
    };
  },
  methods: {
    setData() {
      console.log("Data SEt");
      this.fields = [
        {
          label:
            "sum_of_negative_sales_growth_per_total_no_of_value_for_sales_growth_benchmark",
          name:
            "sum_of_negative_sales_growth_per_total_no_of_value_for_sales_growth_benchmark",
          type: "text",
          value: this.globalData
            .sum_of_negative_sales_growth_per_total_no_of_value_for_sales_growth_benchmark
        },
        {
          label: "number_of_time_sign_change_sales_growth_gt_benchmark",
          name: "number_of_time_sign_change_sales_growth_gt_benchmark",
          type: "text",
          value: this.globalData
            .number_of_time_sign_change_sales_growth_gt_benchmark
        },
        {
          label: "last_year_sales_growth_gt_benchmark",
          name: "last_year_sales_growth_gt_benchmark",
          type: "text",
          value: this.globalData.last_year_sales_growth_gt_benchmark
        },
        {
          label:
            "sum_of_negative_profit_growth_per_total_no_of_value_for_profit_growth_benchmark",
          name:
            "sum_of_negative_profit_growth_per_total_no_of_value_for_profit_growth_benchmark",
          type: "text",
          value: this.globalData
            .sum_of_negative_profit_growth_per_total_no_of_value_for_profit_growth_benchmark
        },
        {
          label: "number_of_time_sign_change_profit_growth_gt_benchmark",
          name: "number_of_time_sign_change_profit_growth_gt_benchmark",
          type: "text",
          value: this.globalData
            .number_of_time_sign_change_profit_growth_gt_benchmark
        },
        {
          label: "last_year_profit_growth_gt_benchmark",
          name: "last_year_profit_growth_gt_benchmark",
          type: "text",
          value: this.globalData.last_year_profit_growth_gt_benchmark
        },
        {
          label: "avg_gross_margin_gt_benchmark",
          name: "avg_gross_margin_gt_benchmark",
          type: "text",
          value: this.globalData.avg_gross_margin_gt_benchmark
        },
        {
          label:
            "sum_of_all_positive_for_change_in_gross_margin_per_total_no_of_value_for_change_in_gross_margin_gt_benchmark",
          name:
            "sum_of_all_positive_for_change_in_gross_margin_per_total_no_of_value_for_change_in_gross_margin_gt_benchmark",
          type: "text",
          value: this.globalData
            .sum_of_all_positive_for_change_in_gross_margin_per_total_no_of_value_for_change_in_gross_margin_gt_benchmark
        },
        {
          label: "avg_roe_gt_benchmark",
          name: "avg_roe_gt_benchmark",
          type: "text",
          value: this.globalData.avg_roe_gt_benchmark
        },
        {
          label: "latest_roe_gt_benchmark",
          name: "latest_roe_gt_benchmark",
          type: "text",
          value: this.globalData.latest_roe_gt_benchmark
        },
        {
          label:
            "count_of_negative_for_change_in_cfo_per_ebitda_per_total_no_of_values_change_in_cfo_per_ebitda_gt_benchmark",
          name:
            "count_of_negative_for_change_in_cfo_per_ebitda_per_total_no_of_values_change_in_cfo_per_ebitda_gt_benchmark",
          type: "text",
          value: this.globalData
            .count_of_negative_for_change_in_cfo_per_ebitda_per_total_no_of_values_change_in_cfo_per_ebitda_gt_benchmark
        },
        {
          label:
            "count_of_negative_for_change_in_lna_per_net_worth_per_total_no_of_values_change_in_lna_per_net_worth_gt_benchmark",
          name:
            "count_of_negative_for_change_in_lna_per_net_worth_per_total_no_of_values_change_in_lna_per_net_worth_gt_benchmark",
          type: "text",
          value: this.globalData
            .count_of_negative_for_change_in_lna_per_net_worth_per_total_no_of_values_change_in_lna_per_net_worth_gt_benchmark
        },
        {
          label: "change_in_cfo_per_ebitda_gt_benchmark",
          name: "change_in_cfo_per_ebitda_gt_benchmark",
          type: "text",
          value: this.globalData.change_in_cfo_per_ebitda_gt_benchmark
        },
        {
          label: "change_in_cfo_per_ebitda_lt_benchmark",
          name: "change_in_cfo_per_ebitda_lt_benchmark",
          type: "text",
          value: this.globalData.change_in_cfo_per_ebitda_lt_benchmark
        },
        {
          label: "avg_change_in_cfo_per_ebitda_last_three_year_gt_benchmark",
          name: "avg_change_in_cfo_per_ebitda_last_three_year_gt_benchmark",
          type: "text",
          value: this.globalData
            .avg_change_in_cfo_per_ebitda_last_three_year_gt_benchmark
        },
        {
          label: "change_in_lna_per_net_worth_gt_benchmark",
          name: "change_in_lna_per_net_worth_gt_benchmark",
          type: "text",
          value: this.globalData.change_in_lna_per_net_worth_gt_benchmark
        },
        {
          label: "change_in_lna_per_net_worth_lt_benchmark",
          name: "change_in_lna_per_net_worth_lt_benchmark",
          type: "text",
          value: this.globalData.change_in_lna_per_net_worth_lt_benchmark
        },
        {
          label: "avg_change_in_lna_per_net_worth_last_three_year_gt_benchmark",
          name: "avg_change_in_lna_per_net_worth_last_three_year_gt_benchmark",
          type: "text",
          value: this.globalData
            .avg_change_in_lna_per_net_worth_last_three_year_gt_benchmark
        }
      ];
      console.log(this.globalData.corporate_long_term_interest_rate);
      console.log("Set Value ", this.fields);
    },
    cancel(d) {
      console.log("Cancel =>", d);
    },
    submitForm() {
      console.log("submitpin entered");
      // this.validatePin(pin);
      this.submitPData();
    },
    showSmallModal() {
      this.$refs.smallModal.open();
    },
    getProjectedFormData() {
      console.log("getUpdatedCompnayWiseData", this.pType);
      let myself = this;
      http.get(
        "getUpdatedCompnayWiseData/" + this.company.co_code,
        {},
        (error, callback) => {
          this.globalData = callback[0];
          for (var i in callback[0]) {
            console.log("Callback i", i);
            myself[i] = callback[0][i];
            // myself.globalData = callback.data[0];
            myself.setData();
            myself.setFormData();
            //TODO:: add company updates into our array in future
          }
          console.log("myself", this.globalData);
        }
      );
    },
    submitPData: function(formData) {
      let myself = this;
      console.log("submit form", this.formData, this.globalData);
      this.getData();
      var t = this.pType;
      var data = {};
      data = {
        pData: this.globalData
      };
      console.log(this.pType, data);
      http.post(
        "updateFinalData/" + this.globalData.co_code,
        this.globalData,
        (error, callback) => {
          // myself.$router.push({ name: "settings" });
          //TODO:: add company updates into our array in future
          this.$toastr.success("Updated Successfully!", "", {});
        }
      );
    },
    setFormData() {
      for (var index in this.fields) {
        let field = this.fields[index];
        // console.log(
        //     (field.reletedField.length > 0) + " => Fields Created",
        //     field
        // );
        if (!field.placeholder) field.placeholder = "";
        // if (!field.value) field.value = "";
        if (!field.help) field.help = "";
        this.$set(this.formData, field.name, field.value);
      }
      console.log("this.formData", this.formData);
    },
    getData() {
      console.log(this.globalData);
      let data = {};
      for (let fd in this.fields) {
        let field = this.fields[fd];
        console.log("Field", field.name);
        this.globalData[field.name] = "";
        // this.globalData[field.name].value = this.formData[field.name];
        console.log(
          field.name,
          this.globalData[field.name],
          this.formData[field.name].value
        );
        this.globalData[field.name] = this.formData[field.name];
      }
      console.log(
        "Global Data" + this.globalData,
        JSON.stringify(this.globalData)
      );
    }
  },
  watch: {
    companyData: function(value) {
      console.log("Sel comp Value", value);
      this.globalData = value;
      for (var i in value) {
        console.log("Callback i", i);
        this[i] = value[i];
      }
      this.setData();
      this.setFormData();
    },
    selCompany: function(value) {
      console.log("Company Name", value);
      this.compSel = value;
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/manual-forms/benchmark.vue